// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"WelcomeOnboarding_wrapper__1vNGo","title":"WelcomeOnboarding_title__3lnGB","caption":"WelcomeOnboarding_caption__3fuYk","imageLogo":"WelcomeOnboarding_imageLogo__5N04d"};